import { UserPermissions, UserWithDeletionData } from '../../types'

export type DateFilterKey = 'lastTokenRefresh' | 'mostRecentConversation'

export type DateFilter = {
  key: DateFilterKey
  date: Date
} | null

export const filterFunction = (
  user: UserWithDeletionData,
  searchTerm: string,
  dateFilter: DateFilter,
): boolean => {
  if (user.inviteStatus === 'unknown') return false

  if (dateFilter?.key === 'mostRecentConversation') {
    if (user.mostRecentConversation == null) return false
    if (user.mostRecentConversation > dateFilter.date) return false
  }
  if (dateFilter?.key === 'lastTokenRefresh') {
    if (user.lastTokenRefresh == null) return false
    if (user.lastTokenRefresh > dateFilter.date) return false
  }

  if (!searchTerm) return true

  const lowerSearchTerm = searchTerm.toLowerCase()
  if (user.name.toLowerCase().includes(lowerSearchTerm)) return true
  if (user.email.toLowerCase().includes(lowerSearchTerm)) return true
  if (user.role.includes(lowerSearchTerm)) return true
  if (user.team?.name.toLowerCase().includes(lowerSearchTerm)) return true

  if (user.permissions[searchTerm as keyof UserPermissions]) return true

  return false
}

export const agentFilterFunction = (
  user: UserWithDeletionData,
  searchTerm: string,
  dateFilter: DateFilter,
): boolean => {
  if (user.inviteStatus !== 'unknown') return false

  if (dateFilter?.key === 'mostRecentConversation') {
    if (user.mostRecentConversation == null) return false
    if (user.mostRecentConversation > dateFilter.date) return false
  }
  if (dateFilter?.key === 'lastTokenRefresh') {
    if (user.lastTokenRefresh == null) return false
    if (user.lastTokenRefresh > dateFilter.date) return false
  }

  if (!searchTerm) return true

  const lowerSearchTerm = searchTerm.toLowerCase()
  if (user.name.toLowerCase().includes(lowerSearchTerm)) return true
  if (user.email.toLowerCase().includes(lowerSearchTerm)) return true
  if (user.team?.name.toLowerCase().includes(lowerSearchTerm)) return true

  return false
}
